/** Shared so the consult page and the readiness report cannot drift apart. */
export const CONSULT_COPY = {
  heading: 'Let’s chat',
  body: 'Based on your answers, we need more information from you to determine if we can serve you. Book a free 30 minute consult with our team to learn if Heard is right for your practice.',
  ctaText: 'Book a free consult',
  bookingUrl: 'https://www.joinheard.com/welcome-form',
  returnUrl: 'https://www.joinheard.com',
} as const
